import { render, staticRenderFns } from "./InsButterfly.vue?vue&type=template&id=329f8d3f&scoped=true"
import script from "./InsButterfly.vue?vue&type=script&lang=ts"
export * from "./InsButterfly.vue?vue&type=script&lang=ts"
import style0 from "./InsButterfly.vue?vue&type=style&index=0&id=329f8d3f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329f8d3f",
  null
  
)

export default component.exports